/**
 * Level 11: Underwater Ruins
 * 
 * Ancient submerged temple with unique water physics:
 * - Low gravity (underwater feel)
 * - Bubble decorations
 * - Ancient stone platforms
 * - Magnetic artifacts
 * 
 * @module configs/levels/Level11_UnderwaterRuins
 */

/** @type {import('../LevelTypes').LevelConfig} */
const Level11_UnderwaterRuins = {
    id: 11,
    name: 'Underwater Ruins',
    subtitle: 'Ancient Depths',
    description: 'Explore ancient submerged temples with low gravity.',
    
    worldWidth: 4500,
    worldHeight: 1800,
    playerStart: { x: 150, y: 1500 },
    gravity: 0.5, // Underwater feel
    
    theme: {
        bgGradient: ['#001830', '#003366'],
        platformColor: 0x4a6741,  // Mossy stone
        accentColor: 0x00aaff,
        particleColor: 0x66ccff
    },
    
    platforms: [
        // Starting area - temple entrance
        { x: 0, y: 1600, w: 400, h: 60 },
        { x: 300, y: 1400, w: 180, h: 25 },
        { x: 600, y: 1200, w: 200, h: 30 },
        
        // First chamber
        { x: 900, y: 1500, w: 300, h: 40 },
        { x: 1100, y: 1300, w: 150, h: 25 },
        { x: 1400, y: 1100, w: 180, h: 25 },
        
        // Central ruins
        { x: 1750, y: 1400, w: 350, h: 50 },
        { x: 1900, y: 1150, w: 200, h: 30 },
        { x: 2200, y: 900, w: 180, h: 25 },
        
        // Hidden passage
        { x: 2500, y: 1300, w: 250, h: 40 },
        { x: 2850, y: 1100, w: 200, h: 30 },
        
        // Final chamber
        { x: 3200, y: 1400, w: 400, h: 50 },
        { x: 3500, y: 1200, w: 180, h: 25 },
        { x: 3800, y: 1000, w: 200, h: 30 },
        { x: 4100, y: 1300, w: 400, h: 60 }
    ],
    
    movingPlatforms: [
        { x: 750, y: 1350, w: 120, h: 20, moveY: 200, speed: 0.0015 },
        { x: 2650, y: 1200, w: 140, h: 20, moveX: 180, speed: 0.002 },
        { x: 3650, y: 1100, w: 130, h: 20, moveY: 150, speed: 0.0018 }
    ],
    
    spikes: [
        { x: 1800, y: 1400 },
        { x: 1850, y: 1400 },
        { x: 3250, y: 1400 },
        { x: 3300, y: 1400 }
    ],
    
    stars: [
        { x: 600, y: 1100 },
        { x: 1400, y: 1000 },
        { x: 2200, y: 800 },
        { x: 2850, y: 1000 },
        { x: 3800, y: 900 }
    ],
    
    enemies: [
        { x: 1000, y: 1450 },
        { x: 1950, y: 1350 },
        { x: 3350, y: 1350 }
    ],
    
    door: { x: 4350, y: 1150, w: 50, h: 300 },
    button: { x: 4200, y: 1295 },
    box: { x: 2550, y: 1200, floating: true },  // Floating artifact
    goal: { x: 4400, y: 1200 },
    
    portals: [
        { x1: 500, y1: 1550, x2: 3100, y2: 1350, color: 0x00ffff }
    ],
    
    waterZones: [
        { x: 0, y: 0, w: 4500, h: 1800, alpha: 0.15 }  // Entire level underwater effect
    ],

    decorations: [
        { key: 'decor-temple', centerInLevel: true, scale: 9, alpha: 0.18, scrollFactor: 0.15, depth: -50 },
        { key: 'decor-coral', centerInLevel: true, scale: 6, alpha: 0.25, scrollFactor: 0.25, depth: -45 }
    ],
    
    trampolines: [
        { x: 1650, y: 1400, w: 80 }
    ],
    
    speedrunTargets: { gold: 50, silver: 70, bronze: 95 }
};

export default Level11_UnderwaterRuins;
